import React from 'react';
// import { useTheme } from '@mui/material/styles';
import { Grid, Typography } from '@mui/material';
// import { useNavigate } from 'react-router-dom';
// import { useIntl } from 'react-intl';
// import useWindowSize from '../../hooks/useWindowResize';
// import './ServiceCard.css';

const ServiceCard = ({ image, text /*title, description, id*/ }) => {
	// const theme = useTheme();
	// const { $t } = useIntl();
	// const navigate = useNavigate();
	// const { width } = useWindowSize();

	return (
		<Grid
			display={'flex'}
			alignItems={'end'}
			borderRadius={'20px'}
			position={'relative'}
			overflow={'hidden'}
			minHeight={{ xs: '300px', s: '400px' }}
			maxHeight={'500px'}
			className="service-card"
			style={{
				backgroundImage: `url(${image})`,
				backgroundSize: 'cover',
				backgroundPosition: 'center',
				userSelect: 'none',
			}}
		>
			<Grid
				width={'100%'}
				bgcolor={'#ffffffb2'}
				color={'#444A5D'}
				className="content-box"
				display={'flex'}
				flexDirection={'column'}
				justifyContent={'center'}
				alignContent={'center'}
				height={'max-content'}
				minHeight={'80px'}
			>
				<Typography
					variant="h3"
					fontSize={{ xs: '18px', s: '25px' }}
					padding={'10px'}
					fontWeight={'500'}
					textAlign={'center'}
				>
					{text}
				</Typography>
				{/* <Typography
					className="description"
					padding={'5px'}
					fontSize={'16px'}
				>
					{description}
				</Typography>
				<Button
					variant={'outlinedTwo'}
					style={{
						width: width > theme.breakpoints.values.sm ? 'max-content' : '100%',
					}}
					className="read-more-btn"
					onClick={() => navigate(`services/${id}`)}
				>
					{$t({ id: 'ReadMore' })}
				</Button> */}
			</Grid>
		</Grid>
	);
};

export default ServiceCard;
